import { useEffect } from "react";
import { IMAGES } from "@/lib/site";

function setTag(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export const Seo = ({ title, description, path = "/", jsonLd }) => {
  useEffect(() => {
    const url = `https://prolificmaven.com${path}`;
    if (title) document.title = title;
    if (description) setTag("name", "description", description);
    setCanonical(url);
    setTag("property", "og:title", title);
    setTag("property", "og:description", description);
    setTag("property", "og:url", url);
    setTag("property", "og:type", "website");
    setTag("property", "og:image", IMAGES.og);
    setTag("name", "twitter:card", "summary_large_image");
    setTag("name", "twitter:title", title);
    setTag("name", "twitter:description", description);
    setTag("name", "twitter:image", IMAGES.og);

    let script = document.getElementById("ld-json");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.id = "ld-json";
        script.type = "application/ld+json";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
    window.scrollTo(0, 0);
  }, [title, description, path, jsonLd]);
  return null;
};

export default Seo;
